<ion-app>
  <ion-router-outlet
    #routerOutletElement
    (activate)="onRouterActivate()"
  ></ion-router-outlet>

  <chat-assistant-icon></chat-assistant-icon>

  <chat-assistant-dialogue
    [class.hidden]="!(chatAssistantStore.chatModalIsOpen$ | async)"
  ></chat-assistant-dialogue>

  <app-version-display class="global-version-overlay"></app-version-display>
</ion-app>
